export const dateFormatDayMonthYear = "dd LLL yyyy";
export const dateFormatFullDateWithDay = "EEE, dd LLLL yyyy";
export const dateFormatMonthAndYear = "LLL yyyy";
export const dateFormatCompleteDateWithTime = "dd LLL yyyy, HH:mm:ss";
export const dateFormatCompleteDateWithoutSeconds = "dd LLL yyyy, HH:mm";
export const dateFormatCompleteDateWithTimeLocalized = "FF";
